import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils/cn';
import { AntiochAgentIcon } from './AntiochAgentIcon';

export interface AgentLoadingStateProps {
  title: string;
  description?: string;
  className?: string;
}

/** Minimal centered loading state for Antioch Agent surfaces. */
export function AgentLoadingState({ title, description, className }: AgentLoadingStateProps) {
  return (
    <div
      className={cn(
        'flex h-full min-h-0 flex-1 items-center justify-center bg-white px-6 text-gray-500 dark:bg-[#0d1013] dark:text-gray-400',
        className
      )}
    >
      <div className="flex max-w-[300px] flex-col items-center gap-5 text-center">
        <div className="relative flex size-16 items-center justify-center">
          <div className="relative flex size-14 items-center justify-center rounded-2xl bg-gray-100 text-blue-500 dark:bg-white/[0.05] dark:text-blue-300">
            <AntiochAgentIcon className="relative size-9 text-gray-300 dark:text-gray-600" />
            <AntiochAgentIcon className="absolute size-9 animate-shimmer-pulse text-blue-500 dark:text-blue-300" />
          </div>
        </div>
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center gap-2">
            <Spinner size="size-3.5" className="text-blue-500/80 dark:text-blue-300/80" />
            <p className="font-medium text-[14px] text-gray-700 tracking-[-0.01em] dark:text-gray-200">{title}</p>
          </div>
          {description && <p className="text-[12px] text-gray-400 leading-relaxed dark:text-gray-500">{description}</p>}
        </div>
      </div>
    </div>
  );
}
